import { Warning } from '@mui/icons-material';
import { Box, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import PopoverSecretaria from '../PopoverSecretaria';
import ReactComponent from '../ReactComponent';
import AlertaConfirmacaoInclusaoPauta from './AlertaConfirmacaoInclusaoPauta';
import AlertaLiberacaoPublicacao from './AlertaLiberacaoPublicacao';
import AlertaPeticoesPendentes from './AlertaPeticoesPendentes';

class AlertasPauta extends ReactComponent {
    popoverAberto = false;

    handleClickIcone = () => {
        this.popoverAberto = true;
    };

    handleClosePopover = () => {
        this.popoverAberto = false;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            popoverAberto: observable,
            handleClickIcone: action,
            handleClosePopover: action,
            existeAlertaPauta: computed,
            carregandoProcessos: computed
        });
    }

    get existeAlertaPauta() {
        return this.pautaJulgamentoStore.processosPautaSelecionada.find((registro) =>
            this.existeAlertaProcesso(registro)
        );
    }

    existeAlertaProcesso(registro) {
        return (
            !registro.confirmadaInclusaoPauta ||
            !registro.confirmadaPublicacaoPauta ||
            (registro.informacoesAdicionais && registro.informacoesAdicionais.QuantidadePeticoesPendentes > 0)
        );
    }

    get carregandoProcessos() {
        return this.sessaoStore.carregandoSessao || this.pautaJulgamentoStore.carregandoPauta;
    }

    render() {
        if (this.carregandoProcessos || !this.existeAlertaPauta) {
            return null;
        }

        return (
            <>
                <Tooltip title={<Typography>Existem pendências para esta pauta</Typography>}>
                    <Box
                        id="iconeAlertasPauta"
                        style={{ display: 'flex', margin: '12px', cursor: 'pointer' }}
                        onClick={this.handleClickIcone}
                    >
                        <Warning style={{ fill: 'darkorange' }} />
                    </Box>
                </Tooltip>
                {this.popoverAberto && (
                    <PopoverSecretaria
                        open={this.popoverAberto}
                        onClose={this.handleClosePopover}
                        anchorEl={() => document.getElementById('iconeAlertasPauta')}
                        placement="bottom"
                    >
                        <Box style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="h6"
                                color="primary"
                            >
                                Pendências
                            </Typography>
                            <AlertaConfirmacaoInclusaoPauta />
                            <AlertaLiberacaoPublicacao />
                            <AlertaPeticoesPendentes />
                        </Box>
                    </PopoverSecretaria>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(AlertasPauta));
